import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import InfoIcon from '../../../commonComponents/icons/InfoIcon';
import LoggedUserContext from '../../../contextProviders/LoggedUserContext';
import translate from '../../../commonComponents/translate';
import { formatDate } from '../../../services/dateUtilityFunctions';

function NetworkListFilters(props) {
  const { t } = props;

  const { loggedUser } = useContext(LoggedUserContext);
  const { forecast } = loggedUser || {};
  const { date } = forecast || {};
  return (
    <div className="info_updated_at">
      <InfoIcon />
      <p>
        <span className="highlight">{t('users.network.info.updatedAt')} </span>
        <span>{date ? formatDate(date, 'YYYY/MM/DD') : '-'}</span>
      </p>
    </div>
  );
}

NetworkListFilters.propTypes = {
  t: PropTypes.func.isRequired,
};

NetworkListFilters.defaultProps = {};

export default translate(NetworkListFilters);
